export default __webpack_public_path__ + "5370427cf315ccfb14451d9fc6eb9ad0.svg";